export default "__VITE_ASSET__CYRMv8T4__"